function StuListArea(props: any) {
  let myProps = {
    stu_info_arr: [],
    set_stu_info_arr: (inData: any) => { },
    ...props
  };

  const on_remove_stu_one = (inData: any) => {
    let opt_obj = {
      stu_seq: "",
      ...inData
    };

    let new_stu_info_arr: any = [];
    for (let i = 0; i < myProps.stu_info_arr.length; i++) {
      if (myProps.stu_info_arr[i].a_seq != opt_obj.stu_seq) {
        new_stu_info_arr.push(myProps.stu_info_arr[i]);
      }
    }
    myProps.set_stu_info_arr(new_stu_info_arr);
  };

  const get_stu_name_tags = () => {
    let name_tags: any = myProps.stu_info_arr.map((item: any, idx: number) => {
      return (
        <span key={idx} className="inline-flex items-center gap-1 px-3 py-1.5 mr-2 mb-2 bg-blue-50 text-blue-700 rounded-full border border-blue-200">
          <span className="text-sm font-medium">{item.a_user_name}</span>
          <button
            className="ml-1 w-5 h-5 flex items-center justify-center rounded-full bg-red-500 hover:bg-red-600 text-white text-xs font-bold transition-colors"
            onClick={() => { on_remove_stu_one({ stu_seq: item.a_seq }); }}
            title="제거"
          >
            ×
          </button>
        </span>
      );
    });
    return name_tags;
  };

  return (
    <div className="p-3 bg-gray-50 rounded-lg border border-gray-200 min-h-[60px]">
      <div className="flex flex-wrap items-center">
        {myProps.stu_info_arr.length > 0 ? (
          get_stu_name_tags()
        ) : (
          <span className="text-gray-400 text-sm">선택된 학생이 없습니다</span>
        )}
      </div>
    </div>
  );
};
export default StuListArea;